import { NgModule } from '@angular/core';
import { LandingPageComponent } from './landing-page.component';
import { SharedProviderModule } from '../shared/shared.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { GridsterModule } from 'angular-gridster2';
import { TrainListComponent } from '../custom/vrgroup/train-list/train-list.component';
import { ScheduledTrainsComponent } from '../custom/vrgroup/scheduled-trains/scheduled-trains.component';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { LandingControllerComponent } from './landing-controller/landing-controller.component';
import { LandingPageService } from './landing-page.service';
import { NgbAccordionModule, NgbModalModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    NgbModalModule,
    NgbAccordionModule,
    NgbNavModule,
    QmPipesModule,
    SharedProviderModule,
    GridsterModule,
    ToolbarModule,
    VrgroupModule
  ],
  declarations: [LandingPageComponent, LandingControllerComponent],
  providers: [LandingPageService]
})
export class LandingPageModule {
}
